export const HiringAccessLevelLabels = {
    recruiter: 'applicant-tracker.accessLevels.onlyRecruiters',
    hiringManager: 'applicant-tracker.accessLevels.onlyRecruitersAndHiringManagers',
    basic: 'applicant-tracker.accessLevels.everyoneOnHiringTeam',
};

export type HiringAccessLevelLabel = 'Recruiter' | 'Hiring Manager' | 'Basic';

type HiringAccessLevel = {
    id: number;
    label: HiringAccessLevelLabel;
};

export const HiringAccessLevels = {
    recruiter: { id: null, label: HiringAccessLevelLabels.recruiter } as HiringAccessLevel,
    hiringManager: { id: 1, label: HiringAccessLevelLabels.hiringManager } as HiringAccessLevel,
    basic: { id: 2, label: HiringAccessLevelLabels.basic } as HiringAccessLevel,
} as const;
